import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../../hooks/useAuth'
import { useCompany } from '../../hooks/useCompany'
import { EarlySignalsLayout } from './EarlySignalsLayout'

export function EarlySignalsGuard() {
  const { user, companyId, isAdmin, passwordRecoveryPending, loading: authLoading } = useAuth()
  const { settings, loading: settingsLoading } = useCompany()
  const location = useLocation()

  // Align with Navbar: undefined = enabled, only explicit false disables
  const earlySignalsEnabled = settings?.features?.earlySignals !== false
  const allowed = !!(user && (isAdmin || (companyId && earlySignalsEnabled)))

  // Wait for the session. Otherwise a direct /early-signals/spend open redirects to
  // /?view=landing before the user is known, and that query keeps the marketing page.
  if (authLoading || settingsLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <i className="fa-solid fa-spinner fa-spin text-3xl text-gray-600" aria-hidden />
        <span className="sr-only">Loading...</span>
      </div>
    )
  }

  // Recovery session must complete set-password on LandingPage (AuthModal lives there)
  if (passwordRecoveryPending) {
    return <Navigate to="/?view=landing" replace />
  }

  if (!allowed) {
    return (
      <Navigate
        to="/?view=landing"
        state={{ from: location, earlySignalsAccessDenied: true }}
        replace
      />
    )
  }

  return <EarlySignalsLayout />
}
